import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/rutas`, options).then(response => {
    return {
      list: response.data.data,
      meta: response.data.meta
    };
  });
}

function line(params) {
  const options = {
    params: params,
    paramsSerializer: function(params) {
      return qs.stringify(params, { encode: false });
    }
  };

  return axios.get(`${url}/lineas`, options).then(response => {
    return {
      line: response.data.data,
      meta: response.data.meta
    };
  });
}

function listRutaTramos(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .get(`${url}/rutas/listRutaTramos/${id}`, options)
    .then(response => {
      return response.data.data;
    });
}

function listActive(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/rutas/listActive`, options).then(response => {
    return {
      listActive: jsona.deserialize(response.data),
    };
  });
}

function add(ruta) {
  const payload = jsona.serialize({
    stuff: ruta,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/rutas`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function addTramo(ruta_tramo) {
  const payload = jsona.serialize({
    stuff: ruta_tramo,
    includeNames: null
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .post(`${url}/rutas/addTramo`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(ruta) {
  const payload = jsona.serialize({
    stuff: ruta,
    includeNames: []
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios
    .patch(`${url}/rutas/${ruta.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function activate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/rutas/activate/${id}`, options);
}

function deactivate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json"
    }
  };

  return axios.put(`${url}/rutas/deactivate/${id}`, options);
}

function destroyTramo(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/rutas/destroyTramo/${id}`, options);
}

export default {
  list,
  line,
  add,
  addTramo,
  update,
  activate,
  deactivate,
  listRutaTramos,
  destroyTramo,
  listActive
};
